import InternalStaticAnchorLogout from 'models/application/anchor/types/internalStatic/types/Logout';

export default class InternalStaticAnchorLogoutService {
	toModel(anchor) {
		return new InternalStaticAnchorLogout(anchor);
	}
}
